<template>
  <div class="mb-3 card ">
    <div v-if="value.name" class="card-header bg-secondary-3">
      <div
        v-if="value.letter"
        class="rounded letter-box mr-2 d-inline-flex align-items-center justify-content-center"
        :style="{
          color: value.letterColor || 'white',
          backgroundColor: `${value.letterColor}14` || '#2db78226',
          borderColor: value.letterColor || '#2db782',
        }"
      >
        <i :class="value.letter || 'fas fa-question'" />
      </div>
      <b class="mr-2">{{ value.name | empty }}:</b>
    </div>
    <div class="card-body bg-secondary-3">
      <div class="mb-3">
        <div v-for="type in value.types" :key="type.id">
          <div v-for="option in type.options" :key="option.id">
            <label class="data-name">{{ option.name }}:</label>
            <validation-provider
              v-slot="{ errors }"
              :rules="isRequired ? 'required' : ''"
            >
              <custom-text-area
                v-model="option.value"
                :count-classes="['d-block', 'small-counter', 'text-right']"
                custom-error-msg="El campo es requerido."
                :disabled="isReadOnly"
                :error="errors[0]"
                :maxlength="5000"
                :show-char-count="!isReadOnly"
              />
            </validation-provider>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import CustomTextArea from 'CustomTextArea';

import Categories from '@/utils/constants/vocationalEvaluationInstrumentAreaCategory.js';

export default {
  name: 'AreaItem',
  components: {
    ValidationProvider,
    CustomTextArea,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    valid: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    options() {
      return this.value.types.flatMap((t) => t.options);
    },
    isRequired() {
      return this.options.map((o) => o.value).some((v) => v);
    },
  },
  watch: {
    valid: {
      handler(value) {
        this.model.valid = value && !this.isRequired;
      },
    },
  },
  methods: {
    getTypeIcon(id) {
      if (id === Categories.SchoolRecommendationsSchool)
        return 'fas fa-house-user';
      if (id === Categories.TutorsRecommendationsTutors) return 'fas fa-users';
      if (id === Categories.SchoolTutorsRecommendationsStudent)
        return 'fas fa-user';
      return 'fas fa-briefcase';
    },
  },
};
</script>

<style scoped>
.letter-box {
  width: 30px;
  height: 30px;
  line-height: 30px;
  display: inline-block;
  text-align: center;
  font-weight: bold;
  border: 1px solid;
}
</style>
